import type { User } from '@supabase/supabase-js';
import { isAppRole, type AppRole, ROLE_HOME } from './types';

/** Extract role from auth user metadata only (no DB round-trip). */
export function roleFromMetadata(user: User | null | undefined): AppRole | null {
  if (!user) return null;
  const role = user.user_metadata?.role;
  return isAppRole(role) ? role : null;
}

/** Only allow same-origin relative paths (blocks open redirects). */
export function safeRedirectPath(
  redirect: string | null | undefined,
  fallback: string
): string {
  if (!redirect) return fallback;
  if (!redirect.startsWith('/') || redirect.startsWith('//')) return fallback;
  if (redirect.includes('\\') || redirect.includes('://')) return fallback;
  return redirect;
}

export function homeForRole(role: AppRole | null | undefined): string {
  if (!role) return '/sign-up-login-screen';
  return ROLE_HOME[role];
}

export function matchProtectedRoute(pathname: string): string | null {
  const prefixes = [
    '/admin-dashboard',
    '/admin-settings',
    '/vendor-portal',
    '/vendor-onboarding',
    '/client-dashboard',
    '/client-portal',
  ];
  return prefixes.find((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)) ?? null;
}
